import { lazy } from "react";
import * as XLSX from "xlsx";

export const sections = [
  {
    id: "beneficiary",
    title: "Dados do Beneficiário",
    component: lazy(() => import("./Beneficiary")),
  },
  {
    id: "economic",
    title: "Unidade Económica",
    component: lazy(() => import("./EconomicUnit")),
  },
  {
    id: "marketAnalysis",
    title: "Análise Mercado",
    component: lazy(() => import("./MarketAnalysis")),
  },
  {
    id: "balance",
    title: "Contas",
    component: lazy(() => import("./BalanceDR")),
  },
  {
    id: "project",
    title: "Dados do Projeto",
    component: lazy(() => import("./ProjectData")),
  },
  {
    id: "domains",
    title: "Dominios das Ações",
    component: lazy(() => import("./ActionDomain")),
  },
  {
    id: "actions",
    title: "Lista de Ações e Indicadores",
    component: lazy(() => import("./Actions")),
  },
  {
    id: "actionDetail",
    title: "Detalhe da Ação",
    component: lazy(() => import("./ActionDetail")),
  },
  {
    id: "rhs",
    title: "Recursos Humanos",
    component: lazy(() => import("./HumanResources")),
  },
  {
    id: "costs",
    title: "Custos",
    component: lazy(() => import("./Costs")),
  },
  {
    id: "operation",
    title: "Descrição da Operação",
    component: lazy(() => import("./OperationDescription")),
  },
  {
    id: "financing",
    title: "Financiamento",
    component: lazy(() => import("./Financing")),
  },
  {
    id: "thematic",
    title: "Enquadramento Temático",
    component: lazy(() => import("./Thematic")),
  },
  {
    id: "selectionCriteria",
    title: "Critérios de Seleção",
    component: lazy(() => import("./SelectionCriteria")),
  },
  {
    id: "declarations",
    title: "Declarações",
    component: lazy(() => import("./Declarations")),
  },
];

export const importFiles = {
  Mérito: (workbook, formData, jsonData, handleChange, setToast) => {
    // F7
    const balanceSheet = workbook.Sheets[`Balanço`];
    const balanceYearCell = balanceSheet["F7"]?.v;
    const balanceIs2025 = balanceYearCell == 2025;

    const balaceHeader = balanceIs2025
      ? ["22", "23", "24", "25", "26", "27", "28", "29", "30", "31"]
      : ["23", "24", "25", "26", "27", "28", "29", "30", "31"];
    const balanceRange = balanceIs2025 ? "C9:L71" : "C9:L71";
    const balaceData = XLSX.utils.sheet_to_json(balanceSheet, {
      range: balanceRange,
      blankrows: true,
      defval: "",
      skipHidden: false,
      header: balaceHeader,
    });

    // F9
    const drSheet = workbook.Sheets[`DR`];
    const drYearCell = drSheet["F9"]?.v;
    const drIs2025 = drYearCell == 2025;

    const drHeader = drIs2025
      ? ["22", "23", "24", "25", "26", "27", "28", "29", "30", "31"]
      : ["23", "24", "25", "26", "27", "28", "29", "30", "31"];
    const drRange = drIs2025 ? "C11:L40" : "C11:K40";

    const drData = XLSX.utils.sheet_to_json(drSheet, {
      range: drRange,
      blankrows: true,
      defval: "",
      skipHidden: false,
      header: drHeader,
    });

    // F3
    const financeSheet = workbook.Sheets[`Financiamento Inter`];
    const yearCell = financeSheet["F3"]?.v;
    const is2025 = yearCell == 2025;

    const range = is2025 ? "F4:J21" : "F4:I21";
    const header = is2025
      ? ["25", "26", "27", "28", "29"]
      : ["26", "27", "28", "29"];

    const financingData = XLSX.utils.sheet_to_json(financeSheet, {
      range: range,
      blankrows: true,
      defval: "",
      skipHidden: false,
      header: header,
    });

    const meritoSheet = workbook.Sheets["Mérito Inter"];
    const activityPerMarketData = XLSX.utils
      .sheet_to_json(meritoSheet, {
        range: "N40:T97",
        blankrows: true,
        defval: "",
        skipHidden: false,
        header: [
          "service",
          "new",
          "country",
          "preQuantity",
          "preValue",
          "postQuantity",
          "postValue",
        ],
      })
      .map((act) => {
        if (!act.country) return;

        const service = jsonData["Services"]?.find(
          (service) => service.label === act.service
        )?.value;
        const country = jsonData["Countries"]?.find(
          (country) => country.label === act.country
        )?.value;
        const new_ = act.new === "Existente" ? "E" : "N";

        const preValue = act.preValue?.toFixed(2);
        const postValue = act.postValue?.toFixed(2);

        return {
          ...act,
          type: "01",
          service,
          new: new_,
          country,
          preValue,
          postValue,
        };
      })
      .filter(Boolean);

    const indirectExportationData = XLSX.utils
      .sheet_to_json(meritoSheet, {
        range: "Z32:AH46",
        blankrows: true,
        defval: "",
        skipHidden: false,
        header: [
          "nif",
          "label",
          "preSells",
          "preVolInter",
          "preVolTotal",
          "u1",
          "postSells",
          "postVolInter",
          "postVolTotal",
        ],
      })
      .map((exp) => {
        if (!exp.label) return;

        delete exp.u1;

        return exp;
      })
      .filter(Boolean);

    handleChange("balance", balaceData);
    handleChange("dr", drData);
    handleChange("financing", financingData);
    handleChange("activityPerMarket", activityPerMarketData);
    handleChange("indirectExportation", indirectExportationData);

    setToast({
      title: "Mérito",
      message:
        "Análise de Mercado, Contas e Financiamento foram carregadas com sucesso!",
      type: "success",
    });
  },
};

function colLetter(colNum) {
  let temp,
    letter = "";
  while (colNum > 0) {
    temp = (colNum - 1) % 26;
    letter = String.fromCharCode(temp + 65) + letter;
    colNum = (colNum - temp - 1) / 26;
  }
  return letter;
}

function splitOnce(str, delimiter) {
  if (!str) return "";

  const index = str.indexOf(delimiter);
  if (index === -1) return "";
  return str.slice(index + delimiter.length).trim();
}

function excelSerialToJSDate(xlSerial) {
  const out = new Date(
    -2209075200000 + (xlSerial - (xlSerial < 61 ? 0 : 1)) * 86400000
  );
  if (isNaN(out.getTime())) {
    return null; // Invalid date
  }
  return out;
}
